import { BreadcrumbLink, type BreadcrumbLinkProps } from '@chakra-ui/react';

export type UiBreadcrumbLinkProps = BreadcrumbLinkProps;

export const UiBreadcrumbLink = BreadcrumbLink;
